import { Badge, Divider, Text } from "@/components/ui";
import type { OptionGroup } from "@/types";

/** "Obrigatório | Máximo N opções" rules row under an option group title (item screen and read-only menu). */
export function OptionGroupRules({ optionGroup }: { optionGroup: Pick<OptionGroup, "minPermitted" | "maxPermitted"> }) {
  const required = Boolean(optionGroup.minPermitted);
  return (
    <div className="flex min-h-5 items-center gap-2">
      {required ? (
        <Badge variant="solid" tone="primary" size="rule">
          Obrigatório
        </Badge>
      ) : (
        <Text size="sm" weight="bold" tone="secondary">
          Opcional
        </Text>
      )}
      <Divider orientation="vertical" className="h-4 self-center" />
      <Text size="sm" weight="bold" tone={required ? "primary" : "secondary"}>
        Máximo {optionGroup.maxPermitted} {optionGroup.maxPermitted > 1 ? "opções" : "opção"}
      </Text>
    </div>
  );
}
